import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { useIntl, defineMessages, FormattedMessage } from "react-intl";
import { FormControl, makeStyles, Select, MenuItem } from "@material-ui/core";
import Jobs from "./jobs";
import Profile from "../header/headerActions/profile";
import MainHeader from "../header/mainHeader";

import "./styles.css";

const messages = defineMessages({
    technicansMainPageTitle: {
        id: "labourer-settings.title",
        defaultMessage: "CMIS",
        description: "Labourer Settings page title",
    },
});

const useStyles = makeStyles((theme) => ({
    container: {
        overflowX: "hidden",
        height: "100vh",
        overflowY: "auto",
    },
    formControl: {
        margin: theme.spacing(0),
        minWidth: 80,
        maxHeight: 40,
    },
    select: {
        height: "35px",
    },
}));

const Technicians = ({ tasks, userInfo }) => {
    const intl = useIntl();
    const [filteredTasks, filterTasks] = useState([]);
    useEffect(() => {
        const yesterday = moment().add(-1, "day").endOf("day");
        const tomorrow = moment().add(1, "day").endOf("day");

        const fTasks = tasks.filter((task) => {
            //const date = moment(task.taskAssignedDate);
            const date = moment(task.scheduledDate);

            if (date > yesterday && date <= tomorrow) {
                return task.resourceAssignedTo && userInfo && task.resourceAssignedTo.relatedKeycloakUserId === userInfo.sub;
            }
            return false;
        });
        fTasks.sort((t1, t2) => {
            // return moment(t1.taskAssignedDate) - moment(t2.taskAssignedDate);
            return moment(t1.scheduledDate) - moment(t2.scheduledDate);
        });
        filterTasks(fTasks);
    }, [tasks]);

    const classes = useStyles();

    const handleChange = () => {
        // handle all filters
    };

    return (
        <div className={classes.container}>
            <div className="main-header">
                <MainHeader subtitle={intl.formatMessage(messages.technicansMainPageTitle)} actions={[<Profile />]} />
                <div id="jobs-header">
                    <div id="jobs-count">
                        <div>
                            <FormattedMessage
                                id="labourer-settings.jobs-count"
                                defaultMessage="{jobsCount} Jobs"
                                description="Tech jobs list jobs count label"
                                values={{
                                    jobsCount: filteredTasks.length,
                                }}
                            />
                        </div>
                        <div className="job-updated">
                            <FormattedMessage
                                id="labourer-settings.updated-on"
                                defaultMessage="Updated {updatedOn}"
                                description="Tech jobs list updated on label"
                                values={{
                                    updatedOn: moment().format("MMM D @ hh:mma"),
                                }}
                            />
                        </div>
                    </div>
                    <div id="jobs-filter">
                        <FormControl variant="outlined" className={classes.formControl}>
                            <Select className={classes.select} id="job-select" value={1} color="primary" onChange={handleChange}>
                                <MenuItem style={{ padding: "3px 10px", color: "blue" }} value={1}>
                                    <FormattedMessage
                                        id="labourer-settings.menu-item-today-tomorrow"
                                        defaultMessage="Today \u0026 Tomorrow"
                                        description="label for menu item"
                                    />
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
            </div>
            <Jobs tasks={filteredTasks}></Jobs>
        </div>
    );
};

const mapStateToProps = (state) => ({
    tasks: state.tasks.tasks,
    userInfo: state.login.userInfo,
});

export default connect(mapStateToProps)(Technicians);
